<app-navbar *ngIf="showHeader"></app-navbar>
<router-outlet></router-outlet>
<ngx-loading-bar [includeSpinner]="false"></ngx-loading-bar>
<app-spinner></app-spinner>
<app-powered-by></app-powered-by>
